/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_CommitInputs */



/**
* | output |
* | --- |
* | "the deck file could not be committed" |
*
* @param {Twda_Failed_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_commit = /** @type {((inputs?: Twda_Failed_CommitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_CommitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("le fichier du deck n'a pas pu être commité")
	if (locale === "es") return /** @type {LocalizedString} */ ("el fichero del mazo no se pudo confirmar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o arquivo do deck não pôde ser commitado")
	if (locale === "it") return /** @type {LocalizedString} */ ("il file del mazzo non è stato committato")
	return /** @type {LocalizedString} */ ("the deck file could not be committed")
});